import state from './moduleNSRState.js'
import mutations from './moduleNSRMutations.js'
import actions from './moduleNSRActions.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions
}

